import type { ILabel } from '@lt/components/components/Label';
import type { PackageStateType } from './types';

export const labelsDTO = (data: unknown): PackageStateType['labels'] => {
  if (data && Array.isArray(data)) {
    return data.map((label) => ({
      id:
        ('id' in label && typeof label.id === 'string') ||
        typeof label.id === 'number'
          ? label.id
          : null,
      title:
        'title' in label && typeof label.title === 'string'
          ? label.title
          : null,
      style:
        'style' in label && typeof label.style === 'number'
          ? label.style
          : null,
      icon_path:
        'icon_path' in label && typeof label.icon_path === 'string'
          ? label.icon_path
          : null,
      description:
        'description' in label && typeof label.description === 'string'
          ? label.description
          : null,
      context: 'context' in label ? labelContextDTO(label.context) : undefined,
      checkout_layout:
        'checkout_layout' in label &&
        (label.checkout_layout === 1 || label.checkout_layout === 2)
          ? label.checkout_layout
          : null,
    }));
  }

  return [];
};

const labelContextDTO = (data: unknown): ILabel['context'] | undefined => {
  if (data && typeof data === 'object') {
    return {
      search:
        'search' in data && (data.search === 1 || data.search === 2)
          ? data.search
          : undefined,
      hotel:
        'hotel' in data &&
        (data.hotel === 1 || data.hotel === 2 || data.hotel === 3)
          ? data.hotel
          : undefined,
    };
  }

  return undefined;
};
